var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_41_47",
    "data-name": "Component 41 \\u2013 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 213.466,
    height: 73.298,
    viewBox: "0 0 213.466 73.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.977,
    y1: 8.052,
    x2: 12.853,
    y2: 8.997,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#057cf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1685f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#3495fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#4aa1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#58a8fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5caaff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34001",
    "data-name": "Group 34001",
    transform: "translate(171.5 17.298)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "customer_portal",
    "data-name": "customer portal",
    transform: "translate(-89.5 52)",
    fill: "#57b4fa",
    fontSize: 11,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.107em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CUSTOMER PORTAL")), /*#__PURE__*/React.createElement("line", {
    id: "Line_1716",
    "data-name": "Line 1716",
    x2: 131.465,
    transform: "translate(-89.5 32.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.18
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rhybus_transparent_background",
    "data-name": "Rhybus transparent background",
    transform: "translate(-54.75 -111.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20291",
    "data-name": "Path 20291",
    d: "M92.731,135.831h0L98.44,111.72l-43.69,41.1,34.363,7.079h0L83.4,184.006l43.69-41.1Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32661",
    "data-name": "Group 32661",
    transform: "translate(136.905 113.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32660",
    "data-name": "Group 32660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20292",
    "data-name": "Path 20292",
    d: "M505.71,228.7V203.078h5.97v3.43c1.751-1.751,3.772-3.43,9.3-3.927V209.5c-6.667,0-8.757,6.7-8.757,10.884V228.7Z",
    transform: "translate(-505.71 -193.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20293",
    "data-name": "Path 20293",
    d: "M667.7,159.843V124.39h6.4v13.233a8.62,8.62,0,0,1,7.374-3.467c5.177,0,9.425,3.077,9.425,11.036v14.65h-6.4V146.609c0-4.3-2.051-6.251-5.079-6.251-3.174,0-5.323,2.686-5.323,6.543v12.941Z",
    transform: "translate(-648.368 -124.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20294",
    "data-name": "Path 20294",
    d: "M894.476,210.73l-5.085,12.731a.012.012,0,0,1,0,.008l-3.368,8.436c-2.248,4.888-4.193,7.4-6.5,9.431a15.439,15.439,0,0,1-7.818,3.769l-1.681-6.274a13.48,13.48,0,0,0,4.3-2.034,9.291,9.291,0,0,0,2.764-2.778,2.889,2.889,0,0,0,.245-2.679L868.89,210.73h4.18a3.9,3.9,0,0,1,3.605,2.408l5.056,12.193h.1l5.315-13.243a2.163,2.163,0,0,1,2.008-1.358Z",
    transform: "translate(-825.549 -200.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32659",
    "data-name": "Group 32659",
    transform: "translate(68.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32658",
    "data-name": "Group 32658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20295",
    "data-name": "Path 20295",
    d: "M1090.485,123.241l-5.573,16.8.1.037c2.88-3.948,6.474-5.864,9.882-5.864,5.438,0,6.721,4.511,6.171,8.759-.927,7.155-7.614,16.4-16.549,16.4-3.308,0-6.518-1.341-5.93-5.877a22.527,22.527,0,0,1,.78-3.321l8.854-26.942h2.269Zm-8.875,26.816a15.571,15.571,0,0,0-.737,3.271c-.344,2.656.969,4.123,4.1,4.123,7.582,0,12.976-8.459,13.761-14.523.44-3.4-.63-6.741-4.628-6.741-4.2,0-9.2,4.4-11.492,10.94Z",
    transform: "translate(-1078.512 -123.24)",
    fill: "#3aacff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20296",
    "data-name": "Path 20296",
    d: "M1301.352,219.85l-5.636,17.581c-.767,2.444-1.358,4.586-1.779,6.479h-2.13l1.378-4.937h-.1c-2.35,3.146-5.974,5.488-9.332,5.488-2.619,0-6.33-1.053-5.543-7.117a20.537,20.537,0,0,1,.945-3.809l4.4-13.683h2.255L1281.4,233.6a20.57,20.57,0,0,0-.924,3.747c-.4,3.082.608,5.075,4.079,5.075,3.4,0,8.574-3.9,10.351-9.486l4.189-13.082h2.254Z",
    transform: "translate(-1254.283 -208.321)",
    fill: "#3aacff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20297",
    "data-name": "Path 20297",
    d: "M1454.83,237a7.6,7.6,0,0,0,4.306,1.39,6.106,6.106,0,0,0,6.2-5.025c.3-2.319-.408-3.722-2.874-5.288-2.58-1.654-3.388-3.834-3.11-5.978.481-3.709,4.074-6.88,8.448-6.88a7.049,7.049,0,0,1,4.122,1.166l-1.078,1.93a6.272,6.272,0,0,0-3.588-1.128,5.526,5.526,0,0,0-5.616,4.561c-.292,2.255.814,3.483,2.917,4.862a6.18,6.18,0,0,1,3.136,6.165,8.82,8.82,0,0,1-9,7.582,7.982,7.982,0,0,1-4.943-1.5Z",
    transform: "translate(-1408.97 -204.243)",
    fill: "#3aacff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.325411a8c97768721b8a4da612799cad.svg";
export { ForwardRef as ReactComponent };